// Path: ./src/app/components/AccountCardWrapper/styled.ts
import { styled as MuiStyled, Box } from "@mui/material";
import styled from "styled-components";

export const TopHead = MuiStyled(Box)({
  backgroundColor: "#f58220",
  height: "50px",
  color: "white",
  boxShadow: "0px 2px 3px 0px #00000059",
  display: "flex",
  alignItems: "center",
});
export const Title = styled.div`
  font-size: 22px;
  font-weight: 900;
  font-family: sans-serif;
  margin-left: 25px;
  text-transform: capitalize;
`;
export const CardBox = MuiStyled(Box)({
  width: "100%",
  borderRadius: " 10px 10px 3px 3px",
  overflow: "visible",
  backgroundColor: "#f2f2f2",
});
